// extracted by mini-css-extract-plugin
module.exports = {"component":"SettingsFormPage_component__8HsAJ","content":"SettingsFormPage_content__3nd2z","header":"SettingsFormPage_header__gNhof"};